import { Box, Paper } from '@mui/material'
import React from 'react'

const TwoEqualColumnLayout = ({ children }: { children: React.ReactNode }) => {
  const childrenArray = React.Children.toArray(children)

  const paperSx = {
    flex: 1,
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column' as const,
    overflow: 'auto',
    borderRadius: { xs: 1, sm: 0 },
    boxShadow: { xs: 3, sm: 2 },
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flex: 1,
        minHeight: 0,
        width: '100%',
        flexDirection: 'row',
        gap: 0,
      }}
    >
      <Box
        sx={{
          display: { xs: 'none', sm: 'flex' },
          flexDirection: 'column',
          flex: '1 1 0%',
          minWidth: 0,
          minHeight: 0,
        }}
      >
        <Paper elevation={4} sx={{ ...paperSx, p: 2 }} className="hide-scrollbar">
          {childrenArray[0]}
        </Paper>
      </Box>
      <Box
        sx={{
          display: { xs: 'none', sm: 'flex' },
          flexDirection: 'column',
          flex: '1 1 0%',
          minWidth: 0,
          minHeight: 0,
        }}
      >
        <Paper elevation={4} sx={paperSx} className="hide-scrollbar">
          {childrenArray[1]}
        </Paper>
      </Box>
      <Box
        sx={{
          display: { xs: 'flex', sm: 'none' },
          flexDirection: 'column',
          flex: 1,
          minWidth: 0,
          minHeight: 0,
        }}
      >
        <Paper elevation={4} sx={paperSx} className="hide-scrollbar">
          {childrenArray[2]}
        </Paper>
      </Box>
    </Box>
  )
}

export default TwoEqualColumnLayout
